export default __webpack_public_path__ + "static/media/labProfileLight.9c4b0588.svg";